import clsx from 'clsx';
import type { ReactNode } from 'react';
import config from '~/config';
import { linkUnderlineClasses } from '~/utils';
import { splitStringOnTokens } from '~/utils/string';

export function interpolateLinks(
	body: string,
	{
		termsRedirect,
		privacyPolicyRedirect,
	}: {
		termsRedirect: string;
		privacyPolicyRedirect: string;
	},
): ReactNode {
	const tokens: [RegExp, string][] = [
		[/(terms ).{1,3}( conditions)/gi, 'Terms & Conditions'],
		[/(privacy policy)/gi, 'Privacy Policy'],
	];

	const stringWithTokens = tokens.reduce((acc, [regex, token]) => {
		return acc.replace(regex, `{{${token}}}`);
	}, body);

	const stringParts = splitStringOnTokens(stringWithTokens);
	// If no privacy policy redirect is provided, use the built-in redirection path
	const links: { [key: string]: string } = {
		'{{Terms & Conditions}}': termsRedirect || '/terms-and-conditions',
		'{{Privacy Policy}}': privacyPolicyRedirect || '/privacy-policy',
	};

	return (
		<>
			{stringParts.map((string, index) => {
				if (string.startsWith('{{')) {
					return (
						<a
							key={index}
							target="_blank"
							rel="noreferrer noopener"
							href={links[string]}
							className={clsx(
								'focus:outline-none focus:ring focus:ring-body-heading',
								linkUnderlineClasses,
							)}
						>
							{string.slice(2, -2)}
						</a>
					);
				}

				return string;
			})}
		</>
	);
}
